import React from 'react'
import Layout from './Layout'
import styles from './_layout.css'

export default function YearInReviewLayout (props) {
  return (
    <Layout
      className={styles.yearInReview}
      showAuth={true}
      showShortcuts={false}
      showMobileNav={false}
      showHeader={false}
      showFooter={false}
      navContainer={false}
      middleContainer={false}
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/YearInReviewLayout.jsx